import { render, staticRenderFns } from "./Chapter1_2.vue?vue&type=template&id=0d877d4f&scoped=true&"
import script from "./Chapter1_2.vue?vue&type=script&lang=js&"
export * from "./Chapter1_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d877d4f",
  null
  
)

export default component.exports